import { registry } from './registry'
import { useWidgetEditor } from './state'

export default function Widget(props: {
  id: string
}): React.JSX.Element | null {
  const editor = useWidgetEditor()
  const config = editor.useConfig(props.id)
  if (!config) return null
  const widget = registry(config.widget)
  if (!widget) return null

  const Component = widget.component
  return <Component id={props.id} />
}
